<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: delete-icon.vue
  - Created by: ChanYing
  - Create Date: 2023-07-19 18:23
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <div class="deleteIcon ztn-icon-sm" :class="disabled?'disabled':''" @mouseover="isHover = true" @mouseout="isHover = false">
    <svg
        :width="size || undefined"
        :height="size || undefined"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
      <circle
          cx="8.00033"
          cy="8.00002"
          r="6.83333"
          :stroke="isHover ? 'var(--base-primary-3)' : 'var(--body-aux-1)'"
          stroke-width="var(--icon-stroke-sm)"
      />
      <path
          d="M11.75 5.00536L10.9946 4.25L8 7.24464L5.00536 4.25L4.25 5.00536L7.24464 8L4.25 10.9946L5.00536 11.75L8 8.75536L10.9946 11.75L11.75 10.9946L8.75536 8L11.75 5.00536Z"
          :fill="isHover ? 'var(--base-primary-3)' : 'var(--body-aux-1)'"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: "delete-icon",
  props: {
    disabled: Boolean,
    size: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isHover: false,
    }
  },
}
</script>
<style scoped>
.deleteIcon {
  cursor: pointer;
  display: inline-flex;
}

.deleteIcon svg {
  width: 100%;
  height: 100%;
  display: block;
}

.deleteIcon.disabled {
  cursor: no-drop;
  opacity: 0.5;
}
</style>